"use client";
import React, { Children, useState } from "react";
import Image from "next/image";
import { SlArrowLeft, SlArrowRight } from "react-icons/sl";
import Link from "next/link";
import { ClipLoader } from "react-spinners";
import Carousel from "../../sub-components/Carousel";

const Card: React.FC<Card> = ({
  title,
  description,
  buttonText,
  images,
  btnLink,
  children,
}) => {
  return (
    <div className="card">
      <div className="card-wrapper contain-img">
        <div className="card-inner">
          <h3>{title}</h3>
        {children ? children : null}
        {!children && images ? <Carousel images={images} /> : null}
          <p>{description}</p>
          <Link href={btnLink}>
            <button className="baumaschinen-card-btn btn-primary btn-gray">
              {buttonText}
            </button>
          </Link>
        </div>
      </div>
    </div>
  );
};

export default Card;
